import { render, staticRenderFns } from "./LProjectConfigurationPrivacy.vue?vue&type=template&id=9c99121e&scoped=true&"
import script from "./LProjectConfigurationPrivacy.vue?vue&type=script&lang=js&"
export * from "./LProjectConfigurationPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./LProjectConfigurationPrivacy.vue?vue&type=style&index=0&id=9c99121e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c99121e",
  null
  
)

export default component.exports